import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { buildEndpoint } from '../EndPoints';
import { Group, GroupDataForm, GroupFilters } from '../../models/Group';

const useGroupService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetGroups, setFetchingGetGroups] = useState(false);
    const [fetchingShowGroup, setFetchingShowGroup] = useState(false);
    const [fetchingStoreGroup, setFetchingStoreGroup] = useState(false);
    const [fetchingEditGroup, setFetchingEditGroup] = useState(false);
    const [fetchingCreateGroup, setFetchingCreateGroup] = useState(false);
    const [fetchingUpdateGroup, setFetchingUpdateGroup] = useState(false);
    const [fetchingDeleteGroup, setFetchingDeleteGroup] = useState(false);
    const [fetchingActiveGroup, setFetchingActiveGroup] = useState(false);

    const BASE_PATH = 'auths/groups';

    const getGroups = (groupFilters: GroupFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(groupFilters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');

        doGet({
            ...events,
            url: `${buildEndpoint(BASE_PATH)}?${queryString}`,
            setFetching: setFetchingGetGroups
        });
    };

    const showGroup = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/show`),
            setFetching: setFetchingShowGroup
        });
    };

    const storeGroup = (group: GroupDataForm, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/store`),
            body: group,
            setFetching: setFetchingStoreGroup
        });
    };

    const editGroup = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/edit`),
            setFetching: setFetchingEditGroup
        });
    };

    const createGroup = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/create`),
            setFetching: setFetchingEditGroup
        });
    };

    const updateGroup = (id: number, group: GroupDataForm, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/update`),
            body: group,
            setFetching: setFetchingUpdateGroup
        });
    };

    const deleteGroup = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/delete`),
            setFetching: setFetchingDeleteGroup
        });
    };

    const activeGroup = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`${BASE_PATH}/${id}/active`),
            body: { active: active },
            setFetching: setFetchingActiveGroup
        });
    };

    return {
        fetchingGetGroups,
        fetchingShowGroup,
        fetchingStoreGroup,
        fetchingEditGroup,
        fetchingUpdateGroup,
        fetchingDeleteGroup,
        fetchingActiveGroup,
        fetchingCreateGroup,
        getGroups,
        showGroup,
        storeGroup,
        createGroup,
        editGroup,
        updateGroup,
        deleteGroup,
        activeGroup
    };
};

export default useGroupService;
